import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import '../../styles/Pages.css';

function EnvironmentAwareness() {
    return (
        <div className="page-wrapper">
            <Navbar />
            <div className="page-hero">
                <p className="page-breadcrumb"><a href="/">Home</a> › Academics › Environment Awareness Programme</p>
                <h1>Environment Awareness Programme</h1>
                <p>Cultivating eco-consciousness and sustainable practices on campus.</p>
            </div>
            <div className="page-content">
                <div className="info-card">
                    <h2>About the Programme</h2>
                    <p>The Environment Awareness Programme at Shri Mulikadevi Mahavidyalaya, Nighoj, is a college-level initiative aimed at promoting environmental consciousness among students and the local community. The programme conducts regular activities including plantation drives, cleanliness campaigns, and awareness workshops on environmental issues.</p>
                </div>
                <div className="cards-grid">
                    {[
                        { icon: '🌳', title: 'Tree Plantation Drive', desc: 'Annual plantation of 100+ trees on and around campus.' },
                        { icon: '♻️', title: 'Waste Segregation', desc: 'Dry and wet waste segregation bins on campus.' },
                        { icon: '💧', title: 'Water Conservation', desc: 'Rainwater harvesting awareness and campus initiatives.' },
                        { icon: '🌿', title: 'Botanical Garden', desc: 'College botanical garden developed and maintained by students.' },
                        { icon: '🧹', title: 'Swachh Bharat', desc: 'Regular campus and village cleanliness drives.' },
                        { icon: '📋', title: 'Workshops', desc: 'Lectures and workshops on climate change, biodiversity, etc.' },
                    ].map(a => (
                        <div className="grid-card" key={a.title}>
                            <div style={{ fontSize: '1.8rem', marginBottom: '0.4rem' }}>{a.icon}</div>
                            <h3>{a.title}</h3>
                            <p>{a.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
            <Footer />
        </div>
    );
}
export default EnvironmentAwareness;
